import { useMemo } from "react";
import { router } from "react-query-kit";
import {
  getPagedRequest,
  QueryParams,
  useBaseUrl,
  useInvalidate
} from "@services/api/requests.service";
import { AcademicSessionProps } from "./academicSession.types";

export default function useAcademicSessionApi() {
  const baseUrl = useBaseUrl("/session");

  const academicSessionApi = useMemo(
    () =>
      router("sessions", {
        page: router.query({
          fetcher: (queryParams: QueryParams) =>
            getPagedRequest<AcademicSessionProps>(baseUrl, queryParams)
        })
      }),
    [baseUrl]
  );

  const invalidate = useInvalidate(academicSessionApi);

  return {
    usePageQuery: academicSessionApi.page.useQuery,
    invalidate
  };
}
